export const RESET = 'EXSBWAREHOUSETYPE_UPDATE_RESET'
export const SET_ERROR = 'EXSBWAREHOUSETYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBWAREHOUSETYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBWAREHOUSETYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBWAREHOUSETYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBWAREHOUSETYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBWAREHOUSETYPE_UPDATE_UPDATE_RETRIEVED'
